import { render, staticRenderFns } from "./AgentNew.vue?vue&type=template&id=1afdd78e&scoped=true&"
import script from "./AgentNew.vue?vue&type=script&lang=js&"
export * from "./AgentNew.vue?vue&type=script&lang=js&"
import style0 from "./AgentNew.vue?vue&type=style&index=0&id=1afdd78e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdd78e",
  null
  
)

export default component.exports